module.exports = __webpack_public_path__ + "img/monitoring.bb3d30c5.svg";